"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _excluded = ["tag", "className", "title", "subtitle", "children", "id"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var SectionHeading = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var Tag = props.tag,
    className = props.className,
    title = props.title,
    subtitle = props.subtitle,
    children = props.children,
    id = props.id,
    attributes = _objectWithoutPropertiesLoose(props, _excluded);
  var classes = (0, _clsx.default)('uk-main__heading', className);
  return /*#__PURE__*/_react.default.createElement(Tag, _extends({
    className: classes,
    id: id,
    ref: ref
  }, attributes), /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-main__title"
  }, /*#__PURE__*/_react.default.createElement("h1", {
    tabIndex: "0"
  }, title), subtitle && /*#__PURE__*/_react.default.createElement("small", null, subtitle)), children);
});
SectionHeading.propTypes = {
  /**
   * Optional HTML tag
   */
  tag: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string]),
  /**
   * Title of the section heading
   */
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]).isRequired,
  /**
   * Subtitle of the section heading
   */
  subtitle: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string])
};
SectionHeading.defaultProps = {
  tag: 'header',
  subtitle: ''
};
var _default = exports.default = SectionHeading;